var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.clickOutside),expression:"clickOutside"}],ref:"scrollContainer",staticClass:"aw-smooth-scrollbar"},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }